import React from "react";
import CallToActionDescription from "./call-to-action-description";
import { trackProCardsViewsOnViewport } from "../helpers/helpers";

export default class ProfilesCardsDemolition extends React.Component {



    constructor(props) {
        super(props)

        this.profiles = this.props.profiles.length > 0 ? this.props.profiles : [];
        this.profilesById = this.props.cards
        this.cardsPerPage = 6;
        this.defaultCards = 12;
        // Hub01 to Hub09 limit to 10 cards per page
        if(this.props.place.ht?.includes('Hub')){
			this.defaultCards = 10;
		}
        this.page = 0;

        this.code = this.props.code;
        this.place = this.props.place;
        this.paginated = this.props.paginated
        this.eventClass = this.props.eventClass || "proCardRendered"
        this.cardClass = this.props.cardClass || "card-pro-view"
    }

    componentDidMount() {
        trackProCardsViewsOnViewport(this.eventClass, this.cardClass, 0);
    }

    addQuote = (id) => {
        return (
            <CallToActionDescription 
                detail="Request pricing & availability"
                startVisible={false}
                proid={id}
                class="get-a-quote"
                ondeffCode= 'demolitionQuoteRequest'
            />
        )
    }

    handleRedirect = (data) => {
        const url = data.split(/data-url="([^"]+)/)
        if(url?.length === 3){
            window.location.href = url[1];
        }
    }

    render() {
        const handleClick = async (e) => {
            e.preventDefault();
            var profilesByIdAux = this.profilesById
            const localCode = this.code === 'demolition' ? 'demolition-contractors' : this.code;
            this.page = this.page + 1;
            const previousCount = this.defaultCards + (this.page - 1) * this.cardsPerPage;
            await Promise.all(this.profiles.slice(this.defaultCards + ((this.page - 1)*this.cardsPerPage), (this.defaultCards + this.page*this.cardsPerPage)).map((profile, index) => {
                return fetch('/pros/' + localCode + '/' + profile.id + '.html')
                .then(res => {
                    return res.text();
                })
                .then(res => {
                    if (res.startsWith("<div class=\"flex-head\"")) {
                        res = res.replace(/\[place\]/g, this.place.name);
                        profilesByIdAux[profile.id] = res;
                        return profile
                    }
                    else {
                        throw new Error('Invalid card');
                    }
                    
                }).catch((error) => {
                    profile.remove = 1
                    return profile
                });
            })).then(() => {
                this.setState({
                    profilesById: profilesByIdAux
                })
                return this.forceUpdate()
            })
            trackProCardsViewsOnViewport(this.eventClass, this.cardClass, previousCount);
            return;        
        }

        return (
            <div className="items-grid prof dumpster">
                <div className="container">
                    <div id="profiles-cards-list" className="row">
                        {
                            this.profiles.slice(0, (this.paginated ? (this.defaultCards + this.page*this.cardsPerPage) : this.profiles.length)).filter(item => item.remove != 1).map((profile, index) => {
                               const pro = profile
                               if(this.profilesById[pro.id]){
                                    return (
                                        <div data-proid={pro.id} key={index} className={this.cardClass}>
                                            <div data-id={pro.id} className="item" >
                                                <div dangerouslySetInnerHTML={{__html: this.profilesById[pro.id]}} onClick={() => this.handleRedirect(this.profilesById[pro.id])}>
                                                
                                                </div>
                                                {
                                                    this.addQuote(pro.id)
                                                }
                                            </div>
                                        </div>
                                    )
                                }else{
                                    profile.remove = 1
                                    return <></>
                                }  
                            })
                        }
                    </div>
                    {this.paginated && this.profiles.length > (this.defaultCards + this.page*this.cardsPerPage) &&
                    <div className="load-more-container">
                        <button onClick={handleClick} className="load-more-btn">Show More</button>
                    </div>
                    }
                </div>
            </div>
        )
    }
}